var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FieldRichText, FieldText, ModalBody, ModalFoot, ModalHead, } from '@dixa/lib-shared-habla';
import { boundMethod } from 'autobind-decorator';
import _countBy from 'lodash/countBy';
import _find from 'lodash/find';
import _forEach from 'lodash/forEach';
import _transform from 'lodash/transform';
import _uniqueId from 'lodash/uniqueId';
import { Component } from 'react';
import { connect } from 'react-redux';
import { Field, FieldArray, Form, reduxForm, } from 'redux-form';
import { FlowNodeTypes } from 'components/powerFlowShared/components/types';
import { getConfirmButtonVerb } from 'components/powerFlowShared/helpers/getConfirmButtonVerb';
import { WidgetPreview } from '../../../conversation/components/widgetPreview';
import { getRequestID } from '../../../shared/util/request';
const FORM_NAME = 'chatFlowMenuForm';
const buttonDifference = (newButtons, oldButtons) => {
    const REMOVED = _transform(oldButtons, (result, oldBtn) => {
        const BTN_FOUND_IN_NEW = _find(newButtons, (newBtn) => oldBtn.nodeId === newBtn.nodeId);
        if (!BTN_FOUND_IN_NEW) {
            result.push({
                btn: oldBtn,
                key: _uniqueId(),
            });
        }
    }, []);
    return _transform(newButtons, 
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    (result, newBtn) => {
        const BTN_FOUND_IN_OLD = _find(oldButtons, (oldBtn) => oldBtn.nodeId === newBtn.nodeId);
        if (BTN_FOUND_IN_OLD) {
            if (newBtn.button !== BTN_FOUND_IN_OLD.button) {
                result.RENAMED.push({
                    btn: newBtn,
                    key: _uniqueId(),
                    newLabel: newBtn.button,
                    oldLabel: BTN_FOUND_IN_OLD.button,
                });
            }
        }
        if (!BTN_FOUND_IN_OLD) {
            result.ADDED.push({
                btn: newBtn,
                key: _uniqueId(),
            });
        }
    }, { ADDED: [], REMOVED, RENAMED: [] });
};
const validate = (values) => {
    const errors = {};
    if (!values.buttons || !values.buttons.length) {
        errors.buttons = {
            _error: 'At least one button option must be entered - click on "Add option"',
        };
    }
    else {
        const btnsArrayErrors = [];
        values.buttons.forEach((button, index) => {
            if (!button || !button.button) {
                btnsArrayErrors[index] = { button: 'Required' };
            }
        });
        const counts = _countBy(values.buttons, (btn) => btn.button);
        let index = 0;
        _forEach(counts, (count) => {
            if (count > 1) {
                btnsArrayErrors[index] = { button: "You can't have duplicate options" };
            }
            index++;
        });
        if (btnsArrayErrors.length) {
            errors.buttons = btnsArrayErrors;
        }
    }
    if (!values.text || !values.text.trim().length) {
        errors.text = { _error: 'Please write a message' };
    }
    return errors;
};
const ListButtons = ({ fields, meta: { error, touched, submitFailed }, }) => {
    return (_jsxs("div", { children: [(touched || submitFailed) && error && _jsx("span", { children: error }), fields.map((option, index) => {
                return (_jsx("div", Object.assign({ className: "input-field-option conversational-modal__option" }, { children: _jsx(Field, { name: `${option}.button`, isRequired: true, required: true, type: "option", placeholder: `Eg. "Sales" or "Finance/Billing"`, component: FieldText, label: `Option #${index + 1}`, suffix: {
                            type: 'button',
                            button: {
                                icon: 'trash',
                                onClick: () => fields.remove(index),
                            },
                        } }) }), `option-${index}`));
            }), _jsx("button", Object.assign({ type: "button", className: "btn btn-primary btn-block outlined", disabled: fields.length >= 12, onClick: () => fields.push({}) }, { children: "Add option" }))] }));
};
class ChatMenuModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hasChanges: false,
            initialText: props.payload ? props.payload.text : '',
            text: '',
        };
    }
    handleSaveClick(values) {
        var _a;
        let nodeState;
        const newButtons = {};
        // @FIX - if fixing logic here, UrlTriggerModal will probably need the same update
        const oldButtons = (_a = this.props.payload) === null || _a === void 0 ? void 0 : _a.buttons;
        const formButtons = values.buttons;
        let count = 0;
        _forEach(formButtons, (formBtn) => {
            newButtons[formBtn.button] = Object.assign(Object.assign({}, formBtn), { nodeId: formBtn.nodeId || getRequestID(), order: count });
            count += 1;
        });
        if (oldButtons) {
            const diff = buttonDifference(newButtons, oldButtons);
            diff.REMOVED.forEach(({ btn: { button: btnLabel } }) => {
                nodeState = this.props.updateConnectionLabel(nodeState, this.props.node, btnLabel, '');
                delete newButtons[btnLabel];
            });
            diff.RENAMED.forEach(({ key, oldLabel }) => {
                nodeState = this.props.updateConnectionLabel(nodeState, this.props.node, oldLabel, key);
            });
            diff.RENAMED.forEach(({ key, newLabel }) => {
                nodeState = this.props.updateConnectionLabel(nodeState, this.props.node, key, newLabel);
            });
        }
        const nodeOptions = Object.assign(Object.assign({}, this.props.node), { nodeType: FlowNodeTypes.CHAT_MENU, text: 'Menu', icon: 'i-channels', isRemovable: true, isEditable: true, isAction: false, overlay: [], badges: [], payload: {
                buttons: newButtons,
                text: values.text,
            } });
        this.props.replaceNode(nodeOptions, nodeState);
        this.props.triggerClose();
    }
    handleMessageChange(_event, newText) {
        this.setState({
            text: newText,
            hasChanges: true,
        });
    }
    handleCancel() {
        this.props.triggerClose();
    }
    getTextForPreview() {
        const { node: { nodeType }, messageValue, } = this.props;
        const { initialText } = this.state;
        if (nodeType !== FlowNodeTypes.ACTION && initialText === '') {
            return 'Please select department';
        }
        return messageValue;
    }
    render() {
        const { node, nodeLabel, buttonsValue, handleSubmit, dirty: isChanged, } = this.props;
        return (_jsx("div", Object.assign({ className: "conversational-modal modal-chatflow-holder" }, { children: _jsxs(Form, Object.assign({ onSubmit: handleSubmit(this.handleSaveClick) }, { children: [_jsx(ModalHead, Object.assign({ title: nodeLabel, onClose: this.handleCancel }, { children: "The \"Menu\" action allows you to automate quick inquiries and gain more context before handing complex ones over to your team." })), _jsx(ModalBody, { children: _jsxs("div", Object.assign({ className: "conversational-modal__columns" }, { children: [_jsx("div", Object.assign({ className: "conversational-modal__column" }, { children: _jsx(WidgetPreview, { options: buttonsValue.map((val) => val.button), message: this.getTextForPreview(), className: "conversational-modal__preview" }) })), _jsxs("div", Object.assign({ className: "conversational-modal__column" }, { children: [_jsx(Field, { component: FieldRichText, name: "text", required: true, className: "conversational-modal__editor", label: "Your message" }), _jsx(FieldArray, { name: "buttons", component: ListButtons })] }))] })) }), _jsx(ModalFoot, { confirmOnClick: handleSubmit(this.handleSaveClick), confirmName: getConfirmButtonVerb(node), confirmProps: { disabled: !isChanged }, cancelOnClick: this.handleCancel })] })) })));
    }
}
__decorate([
    boundMethod
], ChatMenuModal.prototype, "handleSaveClick", null);
__decorate([
    boundMethod
], ChatMenuModal.prototype, "handleMessageChange", null);
__decorate([
    boundMethod
], ChatMenuModal.prototype, "handleCancel", null);
const ChatMenuFlowForm = reduxForm({
    form: FORM_NAME,
    enableReinitialize: true,
    validate,
})(ChatMenuModal);
export default connect((state) => {
    const form = state.form[FORM_NAME];
    return {
        buttonsValue: (form === null || form === void 0 ? void 0 : form.values) ? form.values.buttons : [],
        messageValue: (form === null || form === void 0 ? void 0 : form.values) ? form.values.text : '',
    };
})(ChatMenuFlowForm);
